import { API_ENDPOINTS } from "../constants";
import { buildListQuery } from "./agentService";
import { apiClient } from "./apiClient";

export const agentTenantMapping = {
  async createTenantAgentMapping(data: any): Promise<any> {
    const url = `${API_ENDPOINTS.AGENT_TENANT.CREATE}`;
    const result = await apiClient.post<any>(url, data, {
      authenticate: true,
    });
    return (result as any).data ?? (result as unknown as any);
  },

  async listTenantAgentMapping(params: any): Promise<any> {
    const query = buildListQuery(params);
    const url = query
      ? `${API_ENDPOINTS.AGENT_TENANT.LIST}?${query}`
      : API_ENDPOINTS.AGENT_TENANT.LIST;
    const result = await apiClient.get<any>(url, {
      authenticate: true,
    });
    return (result as any).data ?? (result as unknown as any);
  },

  async listTenantMappingFromAgent(payload: { agentTypeId: string}): Promise<any> {
    const url = API_ENDPOINTS.AGENT_TENANT.LIST_TENANTS;
    const result = await apiClient.post<any>(url, payload, {
      authenticate: true,
    });
    return (result as any).data ?? (result as unknown as any);
  }
};